<template>
  <div>

    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-toolbar flat color="white">
      <v-toolbar-title>All Fee</v-toolbar-title>
     <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <!-- <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">New Emi Status</v-btn>
        </template> -->
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.shadhin_one_time" label="Shadhin One Time Fee"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.community_fee" label="Community Fee"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.payment_gateway" label="Payment Gateway Fee"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.extension_fine" label="Extension Fine"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.adjusted_amount_deduction" label="Adjusted Amount Deduction"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.shadhin_one_time }}</td>
        <td class="text-xs-center">{{ props.item.community_fee }}</td>
        <td class="text-xs-center">{{ props.item.payment_gateway }}</td>
        <td class="text-xs-center">{{ props.item.extension_fine }}</td>
        <td class="text-xs-center">{{ props.item.adjusted_amount_deduction }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <!-- <v-icon
            small
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon> -->
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: false,
      search: '',
      apiUrl: 'all-fee',
      headers: [
        {
          text: 'Shadhin One Time Fee',
          align: 'center',
          sortable: false,
          value: 'shadhin_one_time'
        },
        { text: 'Community Fee', align:'center',value: 'community_fee' },
        { text: 'Payment Gateway Fee', align:'center',value: 'payment_gateway' },
        { text: 'Extension Fine', align:'center',value: 'extension_fine' },
        { text: 'Adjusted Amount Deduction', align:'center',value: 'adjusted_amount_deduction' },
        { text: 'Actions', align:'center',value: 'actions' },
      ],
      editedIndex: -1,
      editedItem: {
        shadhin_one_time: '',
        community_fee: '',
        payment_gateway: '',
        extension_fine: '',
        adjusted_amount_deduction: ''
      },
      defaultItem: {
        shadhin_one_time: '',
        community_fee: '',
        payment_gateway: '',
        extension_fine: '',
        adjusted_amount_deduction: ''
      }
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg', 'investorAgreement', 'investeeAgreement', 'userImage', 'docImage']),
      formTitle () {
        return this.editedIndex === -1 ? 'New All Fee' : 'Edit All Fee'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$store.dispatch('setIndexData', [this.apiUrl])
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      editItem (item) {
        this.editedIndex = this.indexData.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.indexData.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.indexData.splice(index, 1)
        this.$store.dispatch('delete', [this.apiUrl, item.id])
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        } else {
          this.$store.dispatch('store', [this.apiUrl, this.editedItem])
        }
        this.close()
      }
    }
  }
</script>